/*
 * @Author: zhangyang yang.zhang@corerain.com
 * @Date: 2023-02-28 17:31:00
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-03 10:52:18
 * @FilePath: \cr-croms-fe\src\utils\regExp.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 校验密码格式 大小写 数字 特殊字符需要有两种
export const regPwd =
  /^(?!([a-zA-Z]+|\d+|[!@#\-+_=~$%^&*?]+)$)[a-zA-Z0-9\!\@\#\-\+\_\=\~\$\%\^\&\*\?]{6,20}$/
